import routerForBrowser from 'redux-little-router/es/environment/browser-router';
import { reduxRoutes } from './constants';

const { reducer, middleware, enhancer } = routerForBrowser({
  routes: reduxRoutes,
});

export {
  reducer as router,
  middleware as routerMiddleware,
  enhancer as routerEnhancer,
};



// WEBPACK FOOTER //
// ./src/routes/redux.js